import { Directive, HostListener, ElementRef, inject } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appArabicOnly]',
  standalone: false
})
export class ArabicOnlyDirective {
  private el = inject(ElementRef);
  private ngControl = inject(NgControl, { optional: true });

  private arabicRegex = /[؀-ۿݐ-ݿﭐ-﷿ﹰ-﻿\s\-']/;

  @HostListener('input', ['$event']) onInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    const value = input.value;

    // Filter out non-Arabic characters
    const filtered = value.split('').filter(char => {
      return this.arabicRegex.test(char);
    }).join('');

    if (filtered !== value) {
      input.value = filtered;
      this.updateFormControl(filtered);
    }
  }

  @HostListener('paste', ['$event']) onPaste(event: ClipboardEvent): void {
    event.preventDefault();
    const pastedText = event.clipboardData?.getData('text') || '';

    // Get cursor position
    const input = this.el.nativeElement as HTMLInputElement;
    const start = input.selectionStart || 0;
    const end = input.selectionEnd || 0;

    // Filter pasted content to only Arabic characters
    const filteredPaste = pastedText.split('').filter(char => {
      return this.arabicRegex.test(char);
    }).join('');

    if (filteredPaste) {
      // Insert filtered text at cursor position
      const before = input.value.substring(0, start);
      const after = input.value.substring(end);
      const newValue = before + filteredPaste + after;

      input.value = newValue;

      // Restore cursor position
      const newCursorPos = start + filteredPaste.length;
      setTimeout(() => {
        input.setSelectionRange(newCursorPos, newCursorPos);
      });

      this.updateFormControl(newValue);
    }
  }

  private updateFormControl(value: string): void {
    if (this.ngControl) {
      this.ngControl.control?.setValue(value, { emitEvent: false });
    }
  }
}
